import './BigText.scss';

class BigText {

	constructor(node) {
		this.node = node;
	}

	init() {
		console.log('BigText');
	}

}

if (typeof JSModules === "object") {
	JSModules['BigText'] = BigText;
} else {
	// initialize section
	let section = new BigText;
	section.init();
}

export default BigText;
